export const JIRA_UPFLOW_TOUCHPOINT = 'jiraUpFlowTouchpoint';
